import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHeadPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={20} height={20} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M2.5 10.834V9.167a7.5 7.5 0 0 1 15 0v1.667'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M17.5 10.833v1.364a6.3 6.3 0 0 1-1.709 4.339c-1.094 1.15-2.577 1.797-4.124 1.797'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M17.5 12.5a1.667 1.667 0 0 1-1.667 1.666H15a1.667 1.667 0 0 1-1.667-1.666V10A1.667 1.667 0 0 1 15 8.333h2.5zm-15 0a1.667 1.667 0 0 0 1.667 1.666H5A1.667 1.667 0 0 0 6.667 12.5V10A1.667 1.667 0 0 0 5 8.333H2.5zM9.286 18.333a.93.93 0 0 1-.674-.293 1.03 1.03 0 0 1-.279-.707v-.5c0-.265.1-.52.28-.707a.93.93 0 0 1 .673-.293h1.428a.93.93 0 0 1 .674.293c.178.187.278.442.278.707v1.5z'
    />
  </svg>
);
export default SvgHeadPhone;
